import React from 'react'
import {Tabs, Cell, Checkbox, Input} from 'zarm'
import Tabulation from '@wap/components/Tabulation'
import Keyboard from '@wap/components/Keyboard'
import {ShowMediaCell} from '@wap/components'
import * as utils from '../utils'
import './index.less'

const {Panel} = Tabs

export default class ExamKeyTabBoard extends React.Component {
  constructor(props) {
    super(props)
    const {data = {}} = this.props
    this.state = {
      data,
      eyeType: 'OD',
      tabKey: 0 // 默认选中的tab
    }
  }

  tabRef = React.createRef()

  /**
   * 处理好的数据成传给保存提交
   * @returns
   */
  handleResult = () => {
    const {data} = this.state
    const {examContent = {}} = data
    return data
  }

  /**
   * 切换输入框的焦点触发
   * @param {*} name
   * @param {*} value
   * @param {*} unavailableText
   */
  onTabChange = (name, value, unavailableText) => {
    let eyeType = ''
    let {tabKey} = this.state

    if (/Od/.test(name)) {
      eyeType = 'OD'
    } else {
      eyeType = 'OS'
    }
    eyeType !== this.state.eyeType && this.setState({eyeType})
  }

  /**
   * tab改变
   */
  onTableChange = active => {
    const eyeType = active === 0 ? 'OD' : 'OS'
    // 聚焦到对应眼别的第一个指标项
    this.handelFocusField(eyeType)
    this.setState({tabKey: active, eyeType})
  }
  /**
   * 当前输入框的值改变时候
   */
  onInputChange = (name, value) => {
    const {data} = this.state
    const {examContent = {}} = data
    const test = {...data, examContent: {...examContent, [name]: value}}
    this.setState({
      data: test
    })
  }

  /**
   * 下一页
   */
  onKeyNext = () => {
    const {eyeType} = this.state
    const {config} = this.props
    const {examIndiList = {}} = config
    // 找到当前的眼别
    const currentEyeTypeList =
      examIndiList[`${eyeType.toLocaleLowerCase()}List`] || []
    // 找到当前眼别的所有指标的list
    let indiList = currentEyeTypeList.map(item => item.list) || []
    indiList = indiList.flat(Infinity)
    const currIndex = this.tabRef.current.onNext()
    if (currIndex === indiList.length) {
      this.setState({tabKey: 1, eyeType: 'OS'})
    }
  }

  /**
   * 键盘退格
   */
  onKeyBackspace = () => {
    this.tabRef.current.onBackspace()
  }

  /**
   * 类型键盘眼别切换
   * @param type 眼别类型
   */
  onKeyTypeChange = type => {
    // 聚焦对应的第一个指标
    this.handelFocusField(type)
  }
  /**
   * 聚焦对应眼别下的第一个检查项指标
   * @param {*} type
   */
  handelFocusField = type => {
    const tabKey = type === 'OD' ? 0 : 1
    // 检查项的配置
    const {config = {}} = this.props
    // 检查项的指标的key
    const {examIndiList = {}} = config // 获取对应眼别的检查项的指标列表
    // 找到对应的指标列表
    const examKeyList = examIndiList[`${type.toLowerCase()}List`] || []
    const examList = examKeyList[0]?.list || []
    // 聚焦的指标的key
    const name = examList[0]?.option?.key
    this.tabRef.current.inputAutoFocusByName(name)
    this.setState({eyeType: type, tabKey})
  }

  /**
   * inputKeyValueChange input的值返回，也可以在onInputChange方法中获取当前改变的值
   * @param value 键盘输入值改变
   */
  onKeyValueChange = value => {
    const {eyeType} = this.state
    const {config} = this.props
    const {examIndiList = {}} = config
    // 找到当前的眼别
    const currentEyeTypeList =
      examIndiList[`${eyeType.toLocaleLowerCase()}List`] || []
    // 找到当前眼别的所有指标的list
    let indiList = currentEyeTypeList.map(item => item.list) || []
    indiList = indiList.flat(Infinity)
    const currentIndex = this.tabRef.current.inputKeyValueChange(value)
    if (currentIndex === indiList.length) {
      this.setState({tabKey: 1, eyeType: 'OS'})
    }
  }
  /**
   * 媒体资源改变
   * @param {Object} record
   */
  onMediaChange = record => {
    const {data} = this.state
    data.examFiles = record
    this.setState({data})
  }
  /**
   * 输入框失去焦点
   *
   */
  onInputBlur = (name, value, element) => {
    const {config} = this.props
    const {examIndiList = {}} = config
    const {odList = [], osList = []} = examIndiList
    // 找到所有的检查项的列表
    const examList = [...odList, ...osList]
    let allExamList = examList.map(item => item.list) || []
    allExamList = allExamList.flat(Infinity) || []
    let key = name
    if (/@/.test(name)) {
      key = name.split('@')[0]
    }
    // 查看当前的检查项是否存在
    const currentExamKey =
      allExamList.find(exam => exam?.option?.key === key) || {}
    const {option = {}} = currentExamKey
    const {format} = option
    // 判断是否需要格式化
    if (format) {
      value = value && utils.format.done(format, value)
    }
    let param = {}
    if (+value > 0) {
      // 处理屈光度和曲率半径的问题
      param = this.handleCaculate(name, value)
    }
    const {data} = this.state
    const {examContent = {}} = data
    const test = {
      ...data,
      examContent: {...examContent, [name]: value, ...param}
    }
    this.setState({
      data: test
    })
    // state控制的则调用此方法
    // this.onInputChange(name, value);
    // 如果是不是state受控的通过以下方法设置
    // this.tabRef.current.setValueByName(name, value);
  }
  /**
   * dataOdFkRadiusOfCurvature，dataOdSkRadiusOfCurvature， dataOsFkRadiusOfCurvature，dataOsSkRadiusOfCurvature（曲率半径）
   * dataOdFkDioptre ， dataOdSkDioptre， dataOsFkDioptre， dataOsSkDioptre，（屈光度）
   * @returns
   */
  handleCaculate = (name, value) => {
    // 如果是曲率半径
    if (/RadiusOfCurvature/.test(name)) {
      // 曲光度的值
      const diopterValue = (337.5 / +value).toFixed(2)
      // 要修改的屈光度的字段
      let diopterField = ''
      if (/Od/.test(name)) {
        diopterField = /Fk/.test(name) ? 'dataOdFkDioptre' : 'dataOdSkDioptre'
      } else {
        diopterField = /Fk/.test(name) ? 'dataOsFkDioptre' : 'dataOsSkDioptre'
      }
      return {[diopterField]: diopterValue}
      // 修改值
      // this.onInputChange(diopterField, diopterValue);
    }
    // 如果是曲光度
    if (/Dioptre/.test(name)) {
      // 曲率半径的值
      const radiusOfCurvatureValue = (337.5 / +value).toFixed(2)
      // 要修改曲率半径的字段
      let radiusOfCurvatureField = ''
      if (/Od/.test(name)) {
        radiusOfCurvatureField = /Fk/.test(name)
          ? 'dataOdFkRadiusOfCurvature'
          : 'dataOdSkRadiusOfCurvature'
      } else {
        radiusOfCurvatureField = /Fk/.test(name)
          ? 'dataOsFkRadiusOfCurvature'
          : 'dataOsSkRadiusOfCurvature'
      }
      return {[radiusOfCurvatureField]: radiusOfCurvatureValue}
      // 修改值
      // this.onInputChange(radiusOfCurvatureField, radiusOfCurvatureValue);
    }
  }

  render() {
    const {eyeType, data, tabKey} = this.state
    const {examContent = {}} = data
    // 检查项的配置
    const {config = {}} = this.props
    // 检查项的指标的key
    const {examIndiList = {}, unavailableKeys = [], examFile} = config
    // 重要1：Tabulation.TabInput 索引不能重复
    // 重要2：Tabulation.TabInput 索引应该是连续的
    // 重要3：Tabulation.TabInput 如果出现要跳过的输入框，它应该有索引并且是连续的，但是它的值是负数log

    return (
      <div className="examTabBoard" style={{background: '#fff'}}>
        <Tabulation
          border // input输入框的的边框是否显示
          defaultMaxLength={1} // 整个组件默认的最大输入值，每个输入框可以通过 maxLength 自定义
          // defaultUnavailableText="@/" // 整个组件默认的不可输入的字符
          onTabChange={this.onTabChange} // 焦点切换时回调 name, value, inputElement?
          onInputChange={this.onInputChange} // 输入时候回调 name, value, inputElement?
          onInputBlur={this.onInputBlur} // 输入框失去焦点后回调 name, value, inputElement?
          ref={this.tabRef}
        >
          <Tabs
            swipeable
            value={tabKey}
            onChange={this.onTableChange}
            className="examItemTabCont"
            style={{padding: '16px'}}
          >
            {['od', 'os'].map((type, index) => {
              // 获取对应眼别的检查项的指标列表
              const examKeyList = examIndiList[`${type}List`] || [] // 获取对应眼别的检查项的指标列表
              const {odList = [], osList = []} = examIndiList
              // od和os的数据集合
              const allEaxmLists = [...odList, ...osList]
              let allEaxmList = allEaxmLists.map(item => item.list)
              allEaxmList = allEaxmList.flat(Infinity) || []

              // 当前的眼别的所有检查项列表
              let currentEyesTypeList = examKeyList.map(item => item.list) || []
              currentEyesTypeList = currentEyesTypeList.flat(Infinity)
              // 总的数量
              const tabIndexList = Array.from(
                new Array(allEaxmList.length).keys()
              )

              return (
                <Panel
                  title={`${['OD', 'OS'][index]}`}
                  key={type}
                  style={{padding: '0 16px'}}
                >
                  {examKeyList.map((item, _index) => {
                    const key = `${_index + 1}`
                    const {list = [], title} = item
                    return (
                      <div style={{display: 'flex'}} key={key}>
                        <div
                          style={{marginTop: '8px', minWidth: '24px'}}
                        >{`${title}${title ? ':' : ''}`}</div>
                        <div style={{display: 'flex'}}>
                          {list.map((exam, index_) => {
                            const keys = `${index_ + 1}`
                            const {placeholder, option} = exam // 每行的数量
                            const {key, suffix, maxLength, width} = option
                            const account = examKeyList.length
                            // 计算出对应的索引
                            const indexs_ =
                              type === 'od'
                                ? index_ + _index * list.length
                                : index_ +
                                  _index * list.length +
                                  currentEyesTypeList.length
                            // 计算出对应的索引
                            const tabIndex = tabIndexList[indexs_]
                            return (
                              <div key={keys} style={{display: 'flex'}}>
                                <Tabulation.TabInput
                                  tabIndex={tabIndex}
                                  name={key}
                                  value={examContent[key]}
                                  maxLength={maxLength}
                                  placeholder={placeholder}
                                  width={width}
                                  className="large_input"
                                />
                                {suffix && index_ + 1 !== account && (
                                  <span style={{lineHeight: '32px'}}>
                                    {suffix}
                                  </span>
                                )}
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    )
                  })}
                  {/* 图片视频类型 */}
                  {examFile === 1 && (
                    <ShowMediaCell
                      {...this.props}
                      fileEyeType={index + 1}
                      max={3}
                      fileType={4}
                      hiddenOther={true}
                      data={data.examFiles || []}
                      onSuccess={record => this.onMediaChange(record)}
                    />
                  )}
                </Panel>
              )
            })}
          </Tabs>
        </Tabulation>
        <div
        //  style={{ position: 'fixed', bottom: '0', left: '0', width: '100%' }}
        >
          <Keyboard
            unavailableKeys={unavailableKeys}
            eyeType={eyeType}
            onKeyNext={this.onKeyNext}
            onKeyBackspace={this.onKeyBackspace}
            onKeyTypeChange={this.onKeyTypeChange}
            onKeyValueChange={this.onKeyValueChange}
          />
        </div>
      </div>
    )
  }
}
